import React, { useContext } from 'react';

import { QueueContext } from '@vlabs/pages/queue/queue-context/QueueContext';
import validate from '@vlabs/shared/validators';
import { Control, SettingsItemWrapper } from '@vlabs/uikit';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import st from './SharedSubFormStyles.module.sass';

const commonStylesProps = {
  className: st.SettingItem,
  titleClassName: st.SettingItem__Title,
  contentClassName: st.SettingItem__Content,
};

export const BasicParametersSubForm = () => {
  const { t } = useTranslation();
  const { register, formState: { errors }, control } = useFormContext();
  const { groups } = useContext(QueueContext);
  const GROUP_OPTIONS = groups.map((group) => ({ value: group, label: group }));

  return (
    <>
      <SettingsItemWrapper
        title={t('videoAnalytics:table_header.name')}
        {...commonStylesProps}
      >
        <Control.Input
          errors={errors}
          {...register('name', {
            maxLength: validate.maxLength(128),
            validate: validate.regex(/^[\p{L}0-9_-]+$/u),
          })}
        />
      </SettingsItemWrapper>

      <SettingsItemWrapper
        title={t('videoAnalytics:table_header.group')}
        {...commonStylesProps}
      >
        <Control.Select
          control={control}
          errors={errors}
          id="group_name"
          isClearable
          isCreatable
          name="description.zone_group"
          options={GROUP_OPTIONS}
          rules={{
            validate: (group) => validate.regex(/^[a-zA-Z0-9_\\-]{1,128}$/)(group?.value),
          }}
        />
      </SettingsItemWrapper>
    </>
  );
};
